import { AUTH_STEP_TYPE, useAuthNavigation } from '@jusbrasil-web/shared-auth-flows'
import { useCallback, useRef, useState } from 'react'

import { useEnsureAuthServerCsrf } from '../../hooks/useEnsureAuthServerCsrf'
import { usePasswordRecovery } from '../../hooks/usePasswordRecovery'
import { ForgotPassword } from '../forgot-password'

export interface ForgotPasswordStepProps {
  email?: string
  onCloseClick?: () => void
}

export function ForgotPasswordStep({ email = '', onCloseClick }: ForgotPasswordStepProps) {
  const navigate = useAuthNavigation()
  const handleRecoverySent = useCallback(() => {
    navigate({ type: AUTH_STEP_TYPE.RECOVERY_SENT })
  }, [navigate])

  const { isLoading, error, handleForgotPasswordSubmit } = usePasswordRecovery({
    onRecoverySent: handleRecoverySent,
  })

  const { ensureAuthServerCsrf } = useEnsureAuthServerCsrf()
  const [isBootstrapping, setIsBootstrapping] = useState(false)
  const isSubmittingRef = useRef(false)

  const handleSubmit = useCallback(
    async (emailValue: string) => {
      if (isSubmittingRef.current) return
      isSubmittingRef.current = true
      setIsBootstrapping(true)
      try {
        await ensureAuthServerCsrf()
        await handleForgotPasswordSubmit(emailValue)
      } finally {
        isSubmittingRef.current = false
        setIsBootstrapping(false)
      }
    },
    [ensureAuthServerCsrf, handleForgotPasswordSubmit]
  )

  return (
    <ForgotPassword
      email={email}
      isLoading={isLoading || isBootstrapping}
      error={error}
      onSubmit={handleSubmit}
      onCloseClick={onCloseClick}
    />
  )
}
